export const StatusBadge = ({ tone = "neutral", children, testid }) => {
    const tones = {
        success: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
        warning: "bg-amber-500/10 text-amber-300 border-amber-500/30",
        danger: "bg-red-500/10 text-red-300 border-red-500/30",
        info: "bg-blue-500/10 text-blue-300 border-blue-500/30",
        neutral: "bg-white/5 text-slate-300 border-white/10",
    };
    return (
        <span
            data-testid={testid}
            className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-full border ${tones[tone]}`}
        >
            {children}
        </span>
    );
};

export const PriorityBadge = ({ prioridade }) => {
    const map = {
        baixa: { tone: "info", label: "Baixa" },
        media: { tone: "warning", label: "Média" },
        alta: { tone: "danger", label: "Alta" },
    };
    const { tone, label } = map[prioridade] || map.media;
    return <StatusBadge tone={tone}>{label}</StatusBadge>;
};
